export default {"src":"/_next/static/media/dot.40f23fca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};